

(function( ){
//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。
		$(window).bind('resize load', function() {
			$('#game-show .show-list >li.tile-box .txt-box').tile(2);
			$('#entertainment-show .show-list >li.tile-box .txt-box').tile(2);
		});


		$(window).resize(function(){
			if($('html').hasClass('width-pc')){
				$('.table-block dl').addClass('is_show');
			}else{
				$('.table-block dl').removeClass('is_show');
			}
		});

		//カテゴリーフィルター
		var _cat     = $('.category-btn li');
		_cat.click(function(){
			_catType = $(this).attr('id');

			if(_catType == 'all'){
				$(this).addClass('current').siblings().removeClass('current');
				$('.time-box').animate({ opacity: "1"}, 300).removeClass('disable');
			}else if(_catType == 'game'){
				$(this).addClass('current').siblings().removeClass('current');
				$('.gs').animate({ opacity: "1"}, 300).removeClass('disable');
				$('.all , .es').animate({ opacity: "0.5"}, 300).addClass('disable');
			}else{
				$(this).addClass('current').siblings().removeClass('current');
				$('.es').animate({ opacity: "1"}, 300).removeClass('disable');
				$('.gs , .all').animate({ opacity: "0.5"}, 300).addClass('disable');
			}
		});

		//日付切り替え
		var _day = $('.day-btn li'),
				_day1= $('.day-1'),
				_day2= $('.day-2');

		_day.click(function(){
			_dayCat = $(this).attr('id');
			if(_dayCat == 'day-1'){
				$(this).addClass('current').siblings().removeClass('current');
				_day1.show();
				_day2.hide();
			}else{
				$(this).addClass('current').siblings().removeClass('current');
				_day2.show();
				_day1.hide();
			}
		});

		//SP タイムテーブルタブ切り替え
		_tabBtn = $('.tab-btn li');
		_tabBtn.click(function(){
			_tabType = $(this).attr('id');

			if(_tabType == 'tab_001'){
				$(this).addClass('current').siblings().removeClass('current');
				$('#xtreme-arena').show().siblings().hide();
			}else if(_tabType == 'tab_002'){
				$(this).addClass('current').siblings().removeClass('current');
				$('#grand-stage').show().siblings().hide();
			}else{
				$(this).addClass('current').siblings().removeClass('current');
				$('#liberty-stage').show().siblings().hide();
			}
		});

		//タイムボックス フォーカスエフェクト
		var _gameShow  = $('.gs').not('.gs-secret'),
				_entertainmentShow = $('.es').not('.es-secret'),
				link = $('.time-box a');

		_actionStart = ((window.ontouchstart !== null) ? 'mouseenter' : 'touchstart'),
		_actionEnd = ((window.ontouchstart !== null) ? 'mouseleave' : 'touchend');

		link.stop().on(_actionStart,function(){
			$(this).css('color' , '#fff');
			$(window).scroll(function(){
			});
		});
		link.stop().on(_actionEnd,function(){
			$(this).css('color' , '#222');
		});

		_gameShow.on(_actionStart,function(){
			$(this).stop().animate({
				"backgroundColor":"#e80f48",
			})
		});
		_gameShow.on(_actionEnd,function(){
			$(this).stop().animate({
				"backgroundColor":"#fff",
			})
		});

		_entertainmentShow.on(_actionStart,function(){
			$(this).stop().animate({
				"backgroundColor": "#01b5fe",
			})
		});

		_entertainmentShow.on(_actionEnd,function(){
			$(this).stop().animate({
				"backgroundColor":"#ffffff",
			})
		});

		//動画モーダル制御
		var _btn = $('.movie-btn-area');
		_btn.click(function(){
			_dataIframe = $(this).attr('data-remodal-target');
			var CloseTrigger = function(el){
				$(el).on('click', function() {
					videoControl("stopVideo");
				});
				function videoControl(action){
					var _playerWindow = $('#' + _dataIframe)[0].contentWindow;
					_playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
				}
			};
			var closeBtnClick = new CloseTrigger('.remodal-close , .remodal-overlay , .remodal-wrapper');
		});





		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
